import PropTypes from 'prop-types';
import React from 'react';

import './stylesheets/Tooltip.scss';

export default function Tooltip(props) {
  const { children, className, content, placement } = props;
  const tooltipContent = content;

  return (
    <div aria-label={tooltipContent} className={`loc-tooltip loc-tooltip--${placement} ${className}`}>
      { children }
    </div>
  );
}

Tooltip.propTypes = {
  /** Content to be placed inside the tooltip */
  content: PropTypes.string.isRequired,

  /** Hovering over children will trigger the tooltip */
  children: PropTypes.node.isRequired,

  className: PropTypes.string,

  /** Location of tooltip relative to child. One of: ['left', 'right', 'top',
    * 'bottom']
    */
  placement: PropTypes.oneOf([
    'top', 'right', 'bottom', 'left'
  ])
};

Tooltip.defaultProps = {
  className: '',
  placement: 'top'
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/push-message-builder/node_modules/@localytics/loc-components/lib/Tooltip.jsx